import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import QRCode from 'qrcode';

// ETTN (e-belge evrensel tekil no) → QR barkod üreten kısayol düğmesi + modal.
// Fatura / İrsaliye detay ekranlarında ve (ileride) Belge Dizaynı'nda yeniden kullanılır.

const ov = {
  position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
};
const cardStyle = {
  background: 'var(--bg-card, #fff)', border: '1px solid var(--border-color, rgba(15,23,42,0.1))',
  borderRadius: 12, padding: 24, width: 360, maxWidth: '90vw', textAlign: 'center',
  boxShadow: '0 24px 70px rgba(15,23,42,0.32)',
};
const btn = {
  border: '1px solid var(--border-color, rgba(15,23,42,0.18))', background: 'var(--bg-card,#fff)',
  color: 'var(--text-primary,#111827)', borderRadius: 8, padding: '7px 14px', cursor: 'pointer', fontSize: 13, fontWeight: 600,
};

export function EttnQrButton({ ettn, buttonStyle, label = '⊞ QR' }) {
  const [open, setOpen] = useState(false);
  const [dataUrl, setDataUrl] = useState('');

  useEffect(() => {
    let alive = true;
    if (open && ettn) {
      QRCode.toDataURL(String(ettn), { width: 320, margin: 1, errorCorrectionLevel: 'M' })
        .then((u) => { if (alive) setDataUrl(u); })
        .catch(() => { if (alive) setDataUrl(''); });
    }
    return () => { alive = false; };
  }, [open, ettn]);

  if (!ettn) return null;

  const printQr = () => {
    if (!dataUrl) return;
    const w = window.open('', '_blank', 'width=420,height=540');
    if (!w) return;
    w.document.write(
      `<html><head><title>ETTN QR</title></head>`
      + `<body style="text-align:center;font-family:ui-monospace,monospace;padding:24px">`
      + `<img src="${dataUrl}" style="width:300px;height:300px"/>`
      + `<div style="margin-top:14px;word-break:break-all;font-size:12px">${String(ettn)}</div>`
      + `<scr${''}ipt>window.onload=function(){window.print();}</scr${''}ipt></body></html>`,
    );
    w.document.close();
  };

  return (
    <>
      <button type="button" style={buttonStyle} onClick={() => setOpen(true)} title="ETTN QR Barkod üret">{label}</button>
      {open && createPortal(
        <div style={ov} onClick={() => setOpen(false)}>
          <div style={cardStyle} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 4px', fontSize: 16, color: 'var(--card-text-strong,#0b2046)' }}>ETTN QR Barkod</h3>
            <div style={{ fontSize: 11, color: 'var(--text-secondary,#6b7280)', wordBreak: 'break-all', marginBottom: 14, fontFamily: 'ui-monospace, monospace' }}>{String(ettn)}</div>
            {dataUrl
              ? <img src={dataUrl} alt="ETTN QR" style={{ width: 260, height: 260 }} />
              : <div style={{ padding: 40, color: 'var(--text-secondary,#6b7280)' }}>Üretiliyor…</div>}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 16 }}>
              {dataUrl && <a href={dataUrl} download={`ETTN-${ettn}.png`} style={{ ...btn, textDecoration: 'none' }}>İndir</a>}
              <button type="button" style={btn} onClick={printQr}>Yazdır</button>
              <button type="button" style={btn} onClick={() => setOpen(false)}>Kapat</button>
            </div>
          </div>
        </div>,
        document.body,
      )}
    </>
  );
}

export default EttnQrButton;
